module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAQCAYAAAAiYZ4HAAAAqUlEQVR4AZSQsQ2DMBBF7VQp02WFjJF0WSITMEBmSJ8R0kaswBjQUVJS0plnhE6cDoxB99Bh/kPcndzBSwkhhAKuqW+IQLAg+IWKflMSgeAfarjBpiSC974j+ICkJAJBlyMpIUcywp60KkQJemgh1oVbxK0KrPVMoIQnxGXcma+ht0IqbIS9sBJywkrg4Q3mnzlTtRz6w5sfyID0pkRgCwO8YNqGSc4HIwAAAP//vpPTHAAAAAZJREFUAwChxk0h3yne6gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/pageRight2.png
// module id = sODV
// module chunks = 20